import React, { FC } from 'react';

const AddPayment: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M134.2 163.52H65.9603C49.6403 163.52 36.3203 150.24 36.3203 133.88V65.68C36.3203 49.36 49.6003 36.04 65.9603 36.04H134.2C150.52 36.04 163.84 49.32 163.84 65.68V133.92C163.84 150.24 150.56 163.52 134.2 163.52Z"
        fill="#EFF2F4"
      />
      <path
        d="M142.72 131.56H58.3199C53.4399 131.56 49.4399 127.6 49.4399 122.72V76.5199C49.4399 71.6399 53.3999 67.6799 58.3199 67.6799H142.72C147.6 67.6799 151.56 71.6399 151.56 76.5199V122.68C151.56 127.6 147.6 131.56 142.72 131.56Z"
        fill="#FF2B85"
      />
      <path
        d="M74.32 93.7599H61.64C59.8 93.7599 58.28 92.2399 58.28 90.3999V80.6399C58.28 78.7999 59.8 77.2799 61.64 77.2799H74.32C76.16 77.2799 77.68 78.7999 77.68 80.6399V90.3999C77.68 92.2799 76.16 93.7599 74.32 93.7599Z"
        fill="#EFF2F4"
      />
      <path
        d="M122.28 125.44C122.28 116.12 129.84 108.56 139.16 108.56C148.48 108.56 156.04 116.12 156.04 125.44C156.04 134.76 148.48 142.32 139.16 142.32C129.84 142.32 122.28 134.76 122.28 125.44Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.35 125.32C129.35 124.364 130.124 123.589 131.08 123.589H146.84C147.796 123.589 148.571 124.364 148.571 125.32C148.571 126.276 147.796 127.05 146.84 127.05H131.08C130.124 127.05 129.35 126.276 129.35 125.32Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.96 115.949C139.916 115.949 140.69 116.724 140.69 117.68V133.4C140.69 134.356 139.916 135.13 138.96 135.13C138.004 135.13 137.229 134.356 137.229 133.4V117.68C137.229 116.724 138.004 115.949 138.96 115.949Z"
        fill="white"
      />
      <path
        d="M59.9998 111.08H103.32C104.36 111.08 105.24 111.92 105.24 113C105.24 114.04 104.4 114.92 103.32 114.92H59.9998C58.9598 114.92 58.0798 114.08 58.0798 113C58.0798 111.92 58.9598 111.08 59.9998 111.08Z"
        fill="white"
      />
      <path
        d="M59.9998 119.32H103.32C104.36 119.32 105.24 120.16 105.24 121.24C105.24 122.28 104.4 123.16 103.32 123.16H59.9998C58.9598 123.16 58.0798 122.32 58.0798 121.24C58.0798 120.16 58.9598 119.32 59.9998 119.32Z"
        fill="white"
      />
      <path
        d="M120 77.72H144.36C145.36 77.72 146.2 78.52 146.2 79.56C146.2 80.56 145.4 81.4 144.36 81.4H120C119 81.4 118.16 80.6 118.16 79.56C118.2 78.56 119 77.72 120 77.72Z"
        fill="white"
      />
    </svg>
  );
};

export default AddPayment;
